<template>
  <div style="min-height: calc(100vh - 136px)">
    <div class="title">
      <div class="title--newFont">
        <span v-if="finish_type == 0">{{ $t("新增工序委外收货单") }}</span>
        <span v-if="finish_type == 1">{{ $t("修改工序委外收货单") }}</span>
      </div>
      <div style="text-align: right">
        <el-button
          size="small"
          v-if="finish_type == 0"
          class="btnOne"
          @click="saveData"
          >{{ $t("提交") }}</el-button
        >
        <el-button
          size="small"
          v-if="finish_type == 1"
          class="btnOne"
          @click="saveData"
          >{{ $t("保存") }}</el-button
        >
        <el-button size="small" class="btnTwo" @click="backHome">{{
          $t("返回")
        }}</el-button>
      </div>
    </div>
    <hr />
    <!-- 内容 -->
    <div>
      <div style="height: 40px"></div>

      <myTable
        v-loading="listLoading"
        :id="'myTableOne'"
        :columnType="'columnIndex'"
        :list="itemList"
        :titleList="titleList"
        :tableBtnList="itemTableBtnList"
        @btnClick="productBtnClick"
        @selectChangeEvent="selectChangeEvent"
        @selectAllCheckboxChange="selectAllCheckboxChange"
        @resizableChange="resizableChange"
        @customClick="customClick"
        ref="myTableOne"
      ></myTable>
    </div>
  </div>
</template>
<script>
import { selcetSetting, updateSetting, _debounce, customMenu } from "@/utils/myUtils";
import {
  processOutsourcingReceive_add,
  processOutsourcingReceive_update,
} from "@/api/myController/outsourcing";

export default {
  props: {
    // 页面传进来判断入库的值
    routeType: {
      type: Array,
      default: null,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    // 审核权限
    examineType: {
      type: Number,
      default: null,
    },
    finish_type: {
      type: Number,
      default: 0,
    },
    itemList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // 新增数据
    addData: {
      default: () => ({}),
    },
  },
  components: {},
  data() {
    return {
      flag: false,
      // ------------------基础数据
      hrefProData: {},
      listLoading: false,
      btnLoading: false,
      proList: [],
      itemListPro: [],
      itemTableBtnList: [],
      titleList: [
        {
          id: 1,
          name: this.$t("收货单号"),
          value: "processOutsourcingReceiveDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: true,
          alwaysEditState: true,
          width: 120,
        },
        {
          id: 1,
          name: this.$t("关联单号"),
          value: "baseProcessOutsourcingDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
        },
        {
          id: 1,
          name: this.$t("全局搜索码"),
          value: "globalSearchNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
        },
        {
          id: 3,
          name: this.$t("产品编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
        },
        {
          id: 4,
          name: this.$t("产品名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 150,
        },
        {
          id: 2,
          name: this.$t("规格型号"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          alwaysEditState: false,
          canEdit: false,
          width: 200,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 9,
          name: this.$t("本次收货数量"),
          value: "baseOutsourcingFinishedQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: true,
          alwaysEditState: true,
          width: 100,
        },
        {
          id: 9,
          name: this.$t("入库日期"),
          value: "baseInwarehouseTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: true,
          alwaysEditState: true,
          width: 120,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,
          alwaysEditState: true,
          width: 180,
        },
      ],
      // 转单数据
      sysDocRelationDto: {
        baseMaterialFromPrice: 0,
        baseMaterialId: 0,
        baseMaterialSpecgroupId: 0,
        baseMaterialToPrice: 0,
        createDeptId: 0,
        relationDocDetailFromId: 0,
        relationDocDetailToId: 0,
        relationDocFromId: 0, //来源单据ID
        relationDocToId: 0,
        relationId: 0,
        relationType: 0, //0.不正常，2.正常
        remark: "",
        searchString: "",
        valueMaterialQuantity: 0,
      },
      // 批次号
      dialogState: {
        show1: false,
        show2: false,
      },
      batchNumberList: [],
      batchNumberChangeList: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    $t(val) {
      return val;
    },
    // 初始化
    initData() {
      if (this.finish_type == 0) {
        this.getList(this.routeQuery);
      }
    },
    //
    async getList(data) {
      this.itemList = [data.list];
    },
    // 批次号
    dialogClose() {
      this.dialogState.show1 = false;
      this.dialogState.show2 = false;
    },
    //   质检项目
    customClick(query, val, row, column) {
      switch (column.field) {
        default:
          break;
      }
    },
    // 多选
    selectChangeEvent(val) {
      this.itemListPro = val.records;
    },
    selectAllCheckboxChange(val) {
      this.itemListPro = val.records;
    },
    productBtnClick(row, item, index, state) {
      switch (item) {
        case this.$t("删除"):
          this.$confirm(
            this.$t("确定删除") + "？" + this.$t("是否继续") + "？",
            this.$t("提示"),
            {
              confirmButtonText: this.$t("确定"),
              cancelButtonText: this.$t("取消"),
              type: "warning",
            }
          )
            .then(() => {
              this.itemList.splice(index - 1, 1);
            })
            .catch(() => {
              this.$message.info(this.$t("已取消删除"));
            });
          break;
        default:
          break;
      }
    },
    getBackOrderState() {
      this.$emit("backOrderState");
    },
    // 单个新增
    async saveData() {
      if (this.itemList.length == 0) {
        this.$message.error(this.$t("请选择产品"));
        return;
      }
      let json = {
        processOutsourcingReceiveDto: this.itemList[0],
      };
      if (this.finish_type == 0) {
        await processOutsourcingReceive_add(json).then(async (res) => {
          let json = {
            processOutsourcingReceiveDocId: res.data.data,
          };
          this.$message.success(this.$t("操作成功") + "！");
          this.$emit("backHome", 172, json);
        });
      } else {
        await processOutsourcingReceive_update(json).then(async (res) => {
          this.$message.success(this.$t("操作成功") + "！");
          this.$emit("backOrderState");
        });
      }
    },
    backHome() {
      this.$emit("backHome");
    },
  },
};
</script>
<style scoped>
::v-deep .el-descriptions-item__cell .el-descriptions-item__label .is-bordered-label {
  width: 120px !important;
}
.input {
  width: 100%;
}

.btnOne {
  background: #08a1b8;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title----font {
  color: rgb(8, 161, 184);
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}
</style>
